export { YmalProductsCarousel } from './YmalProductsCarousel';
